/** chat — EN source (79 keys). */
export const chat = {
  chat_messages_title: "Messages",
  chat_messages_unread: "{count} unread",
  chat_messages_empty_title: "No messages yet",
  chat_messages_empty_description:
    "When you match with someone, you can start a conversation here",
  chat_messages_loading: "Loading messages...",
  chat_conversation_typing: "typing...",
  chat_conversation_typing_multiple: "{count} people are typing",
  chat_conversation_no_messages: "No messages yet",
  chat_conversation_no_messages_hint:
    "Send a message to start the conversation",
  chat_conversation_edited: "edited",
  chat_conversation_tap_to_retry: "Tap to retry",
  chat_input_placeholder: "Type a message...",
  chat_input_attachment_gallery: "Gallery",
  chat_input_attachment_camera: "Camera",
  chat_input_attachment_file: "File",
  chat_input_attachment_location: "Location",
  chat_input_replying_to: "Replying to {name}",
  chat_attachment_photo: "Photo",
  chat_attachment_video: "Video",
  chat_attachment_voice: "Voice message",
  chat_attachment_file: "File",
  chat_attachment_location: "Location",
  chat_actions_reply: "Reply",
  chat_actions_copy: "Copy",
  chat_actions_edit: "Edit",
  chat_actions_delete: "Delete",
  chat_actions_forward: "Forward",
  chat_conversation_actions_archive: "Archive",
  chat_conversation_actions_unarchive: "Unarchive",
  chat_conversation_actions_mute: "Mute",
  chat_conversation_actions_unmute: "Unmute",
  chat_conversation_actions_pin: "Pin",
  chat_conversation_actions_unpin: "Unpin",
  chat_conversation_actions_delete: "Delete",
  chat_conversation_actions_block: "Block User",
  chat_time_just_now: "Just now",
  chat_time_yesterday: "Yesterday",
  chat_delete_confirm_title: "Delete Message",
  chat_delete_confirm_message: "Are you sure you want to delete this message?",
  chat_delete_confirm_cancel: "Cancel",
  chat_delete_confirm_delete: "Delete",
  chat_block_confirm_title: "Block User",
  chat_block_confirm_message:
    "Are you sure you want to block {name}? They won't be able to message you.",
  chat_block_confirm_cancel: "Cancel",
  chat_block_confirm_block: "Block",
  chat_error_send_failed: "Failed to send message",
  chat_error_load_failed: "Failed to load messages",
  chat_error_connection: "Connection lost. Reconnecting...",
  chat_options_title: "Options",
  chat_options_leave_channel: "Leave Channel",
  chat_options_leave_group: "Leave Group",
  chat_options_leaving: "Leaving...",
  chat_options_no_options: "No options available",
  chat_leave_channel_title: "Leave channel?",
  chat_leave_channel_message:
    "Are you sure you want to leave this channel? You can rejoin if it's public or if someone invites you again.",
  chat_leave_group_title: "Leave group?",
  chat_leave_group_message:
    "Are you sure you want to leave this group? You can rejoin if it's public or if someone invites you again.",
  chat_leave_confirm_cancel: "Cancel",
  chat_leave_confirm_leave: "Leave",
  chat_leave_error: "Failed to leave {type}. Please try again.",
  chat_channel_admin_only: "Only admins can post in this channel",
  chat_discover_title: "Discover Channels",
  chat_discover_invite_placeholder: "Enter invite code...",
  chat_discover_join_button: "Join",
  chat_discover_public_channels: "Public Channels",
  chat_discover_loading: "Loading channels...",
  chat_discover_empty_title: "No channels found",
  chat_discover_empty_description:
    "There are no public channels available right now. Check back later or join using an invite link.",
  chat_discover_channel_members: "{count} members",
  chat_discover_joining: "Joining...",
  chat_discover_join_error: "Failed to join channel. Please try again.",
  chat_discover_invite_error:
    "Invalid invite code or you cannot join this channel.",
  chat_discover_invite_empty_error: "Please enter an invite code.",
  chat_archive_error: "Failed to archive conversation",
  chat_mute_error: "Failed to mute conversation",
  chat_pin_error: "Failed to pin conversation",
  chat_delete_error: "Failed to delete conversation",
  chat_delete_conversation_title: "Delete Conversation?",
  chat_delete_conversation_message:
    "Are you sure you want to delete this conversation? This cannot be undone.",
};
